import React, { useEffect, useState, useContext } from "react";
import { Trash2 } from "react-feather";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import getUserById from "../requests/getUserById";

const TourUsersTableRow = ({ token, userId, tourId }) => {

  const { user } = useContext(AuthContext);
  const [ tourUser, setTourUser ] = useState({
    firstname: "",
    lastname: "",
    email: ""
  });

  useEffect(() => {
    if (token) {
      getUserById(token, userId).then(response => {
        if (response.status === 200) {
          setTourUser(response.data[0]);
        }
      })
    }
  }, [token, userId]);

  const deletePath = "/delete/tour/" + tourId + "/userRole/" + userId;

  if (!user) return (<></>);

  const iconSize = 20;

  return (
    <tr>
      <td>{tourUser.firstname} {tourUser.lastname}</td>
      <td>{tourUser.email}</td>
      {
        user.uid !== userId &&
        (<td>
          <Link to={deletePath} className="icon-button-link-warning"><Trash2 size={iconSize} /></Link>
        </td>)
      }
      
    </tr>
  )
};

export default TourUsersTableRow;